
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/restaurant",
      function () {
        return require("private-next-pages/restaurant/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/restaurant"])
      });
    }
  